import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import clxBind from 'classnames/bind';
import Button from '../Button';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Radio extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['radio', 'button']),
    mode: PropTypes.oneOf(['info', 'success', 'danger', 'warning']),
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.any,
    className: PropTypes.string,
    children: PropTypes.any,
  };

  static defaultProps = {
    type: 'radio',
    mode: undefined,
    disabled: false,
    checked: false,
    value: '',
    onChange: undefined,
    className: undefined,
    children: null,
  };

  render() {
    const {
      type,
      mode,
      disabled,
      checked,
      onChange,
      value,
      className,
      children,
      ...props
    } = this.props;

    let onInputChange;

    if (isFunction(onChange)) {
      onInputChange = onChange.bind(null, value);
    }

    const radioClasses = clx(
      'radio',
      {
        [`mode-${mode}`]: mode,
        disabled,
        checked,
      },
      className
    );

    switch (type) {
      case 'button':
        return (
          <Button
            type="radio"
            disabled={disabled}
            checked={checked}
            onChange={onInputChange}
            value={value}
            mode={mode}
            {...props}
          >
            {children}
          </Button>
        );
      default:
        return (
          <label className={radioClasses} htmlFor={props.id}>
            <span className={styles['radio-box']}>
              <input
                type="radio"
                className={styles['input']}
                disabled={disabled}
                checked={checked}
                onChange={onInputChange}
                value={value}
                {...props}
              />
            </span>
            {children}
          </label>
        );
    }
  }
}
